import {Component, Input} from '@angular/core';
import {SearchResultEntry} from "../../../../api/models/search-result-entry";
import {DataCompletionService} from "../../../../api/services/data-completion.service";
import {DataCompletionResponse} from "../../../../api/models/data-completion-response";

@Component({
  selector: 'app-search-instrument-driver, [search-instrument-driver]',
  templateUrl: './search-instrument-driver.component.html',
  styleUrls: ['./search-instrument-driver.component.scss']
})
export class SearchInstrumentDriverComponent {
  @Input()
  searchResultEntry!: SearchResultEntry;
  dataCompletionResponse?: DataCompletionResponse;
  driversTableOpened: boolean = false;
  hasError: boolean = false;

  constructor(private dataCompletionService: DataCompletionService) {
  }

  toggleTable() {
    const opened = !this.driversTableOpened;
    if (opened && (!this.dataCompletionResponse || this.dataCompletionResponse?.error)) {
      this.getDataCompletion();
      return;
    } else {
      this.driversTableOpened = opened;
    }
  }

  private getDataCompletion() {
    let params = {
      manufacturer: this.searchResultEntry.manufacturer,
      model: this.searchResultEntry.model,
    }
    this.dataCompletionService.getData(params)
      .subscribe({
        next: response => {
          this.dataCompletionResponse = response;
          this.driversTableOpened = true;
          this.hasError = false;
        }, error: err => {
          this.driversTableOpened = true;
          this.hasError = true;
        }
      });
  }

}
